import React from "react";
import countapi from 'countapi-js';

export default function Footer(){
    const [cnt, setCnt] = React.useState([]);
    const getCnt = async () => {
        const resp = await fetch('https://api.countapi.xyz/update/cpreminder/cpr/?amount=1');
        setCnt(await resp.json());    
    }
    React.useEffect(()=>{
        getCnt();
    }, []);
    console.log(cnt.value)
    return (
        <div>
      <footer>
        <div class="footer-content">
            <h3>The Contest Reminder Project</h3>
            <h3>Total Views</h3>
            <h2 id="count">{cnt.value}</h2>
            {/* <p>Under the Guidance <span className="vinay">Dr. Vinay Rishiwal</span></p> */}
            {/* <p>Developed by <span className="vinay">Mahesh Kumar, Sanjay Gangwar, Piyush Bharti and Vaibhav Giri</span></p> */}
            {/* <p className="devs" >Developed by <span></span></p> */}
            <ul class="socials">
                <li><a href="#"><i class="fa fa-github"></i></a></li>
                <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                <li><a href="#"><i class="fa fa-linkedin-square"></i></a></li>
            </ul>
        </div>
        {/* <div class="footer-bottom">
            <p>A pre-final year Minor Project </p>
        </div> */}
    </footer>
      </div>
    )
}